import { useMemo } from 'react'
import { useData } from '../contexts/DataContext'
import { useLocation } from '../contexts/LocationContext'

export function useLocationHierarchy() {
  const { locations } = useData()
  const { selectedDistrict, selectedSubcounty, selectedParish } = useLocation()

  return useMemo(() => {
    if (!locations?.districts) {
      return {
        availableDistricts: [],
        availableSubcounties: [],
        availableParishes: [],
        availableVillages: [],
      }
    }

    const availableDistricts = [...locations.districts].sort((a, b) =>
      a.name.localeCompare(b.name)
    )

    const selectedDistrictData = availableDistricts.find(
      d => d.id === selectedDistrict
    )
    const availableSubcounties = (selectedDistrictData?.subcounties || []).sort(
      (a, b) => a.name.localeCompare(b.name)
    )

    const selectedSubcountyData = availableSubcounties.find(
      s => s.id === selectedSubcounty
    )
    const availableParishes = (selectedSubcountyData?.parishes || []).sort(
      (a, b) => a.name.localeCompare(b.name)
    )

    const selectedParishData = availableParishes.find(
      p => p.id === selectedParish
    )
    const availableVillages = (selectedParishData?.villages || []).sort(
      (a, b) => a.name.localeCompare(b.name)
    )

    return {
      availableDistricts,
      availableSubcounties,
      availableParishes,
      availableVillages,
      selectedDistrictData,
      selectedSubcountyData,
      selectedParishData,
    }
  }, [locations, selectedDistrict, selectedSubcounty, selectedParish])
}
